// @flow

import unifizeUser from "./index";
import Picture from "src/components/user/picture";

export default unifizeUser(Picture);
